import { useState } from 'react';
import { TYPE_BUTTONS } from '../../../../constans';
import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import H2 from '../../../Basic/WrapsStyle/H/H2';

import UserApi from '../../../../API/user/user-api';
import PopUp from '../../../Basic/Blocks/PopUp';
import Input from '../../../Basic/Inputs/Base';
import styles from './styles.module.scss';

const ChangeUserPassPopUp = ({ user = {}, close = () => { } }) => {
  const [password, setPass] = useState('');

  const clickChange = () => {
    UserApi.changePassword({ data: { login: user.login, password } })
      .then((r) => {
        close();
      })
      .catch();
  };
  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Изменить пароль</H2>
      <Input
        value={password}
        label="Новый пароль"
        width="80%"
        onChange={(v) => setPass(v)}
        style={{ marginBottom: '15px' }}
      />

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          disabled={password.length < 6}
          onClick={clickChange}
        >
          Сохранить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default ChangeUserPassPopUp;
